module.exports = __webpack_public_path__ + "static/media/dmsans-bold-webfont.44017bf5.woff2";